import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { useApp } from "@/contexts/AppContext";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
    const { settings } = useApp();
    const { t } = useI18n();
    const brand = settings.brand_name || "Bizlinkk";
    return (
        <footer className="mt-24 border-t border-border/70">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 sm:grid-cols-4 gap-8">
                <div className="col-span-2">
                    <Link to="/" className="flex items-center gap-2.5">
                        <div className="w-7 h-7 rounded-full sphere" />
                        <span className="font-heading text-sm font-semibold uppercase tracking-[0.22em]">{brand}</span>
                    </Link>
                    <p className="mt-3 text-sm text-muted-foreground max-w-sm">
                        {settings.tagline} {t("home_sub")}
                    </p>
                    <div className="mt-4 flex items-center gap-2.5" data-testid="footer-socials">
                        <a href="https://www.instagram.com/bizlinkkofficial/" target="_blank" rel="noopener noreferrer" aria-label="Bizlinkk on Instagram" className="w-9 h-9 rounded-full glass flex items-center justify-center text-muted-foreground hover:text-accent transition-colors" data-testid="social-instagram">
                            <Instagram className="w-4 h-4" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=61588703384691" target="_blank" rel="noopener noreferrer" aria-label="Bizlinkk on Facebook" className="w-9 h-9 rounded-full glass flex items-center justify-center text-muted-foreground hover:text-accent transition-colors" data-testid="social-facebook">
                            <Facebook className="w-4 h-4" />
                        </a>
                        <a href="https://www.youtube.com/@Bizlinkk" target="_blank" rel="noopener noreferrer" aria-label="Bizlinkk on YouTube" className="w-9 h-9 rounded-full glass flex items-center justify-center text-muted-foreground hover:text-accent transition-colors" data-testid="social-youtube">
                            <Youtube className="w-4 h-4" />
                        </a>
                    </div>
                </div>
                <div>
                    <div className="text-xs font-medium tracking-wide uppercase text-muted-foreground mb-3">{t("nav_home")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><a href="/#how" className="hover:text-foreground text-muted-foreground">{t("nav_how")}</a></li>
                        <li><Link to="/pricing" className="hover:text-foreground text-muted-foreground">{t("nav_pricing")}</Link></li>
                        <li><Link to="/b/royal-garments" className="hover:text-foreground text-muted-foreground">{t("nav_example")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="text-xs font-medium tracking-wide uppercase text-muted-foreground mb-3">{t("create_website")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/signup" className="hover:text-foreground text-muted-foreground">{t("signup")}</Link></li>
                        <li><Link to="/login" className="hover:text-foreground text-muted-foreground">{t("login")}</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-border/70 py-5 text-center text-xs text-muted-foreground">
                © {new Date().getFullYear()} {brand}. All rights reserved.
            </div>
        </footer>
    );
}
